import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 px-6 lg:px-12 bg-white">
      <div
        className="relative rounded-2xl overflow-hidden"
        style={{ background: "linear-gradient(135deg, #1a1a1a 0%, #2d2010 50%, #1a1a1a 100%)" }}
      >
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20golden%20geometric%20pattern%20texture%2C%20luxury%20background%2C%20dark%20gold%20tones%2C%20elegant%20decorative%20pattern&width=1200&height=400&seq=cta001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 py-14 px-8 md:px-16 text-center">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/30 rounded-full px-3 py-1 mb-5">
            <div className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></div>
            <span className="text-amber-300 text-xs font-medium">現在加入，立享分銷商專屬優惠</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
            加入吉時分銷商，今天就開始賺差價
          </h2>
          <p className="text-white/60 text-sm md:text-base mb-8">
            無需囤貨 · 一件代發 · 後台即時追蹤 · 工廠直供低價
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/register"
              className="px-8 py-3 bg-amber-500 hover:bg-amber-400 text-white font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              立即申請分銷商資格 →
            </Link>
            <Link
              to="/products"
              className="px-8 py-3 border border-white/30 hover:border-white/60 text-white font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              先瀏覽商品
            </Link>
          </div>

          {/* Stats row */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-10 pt-8 border-t border-white/10">
            {[
              { value: "10,000+", label: "精選跨境商品" },
              { value: "5,000+", label: "活躍分銷商" },
              { value: "30+", label: "覆蓋國家地區" },
              { value: "98%", label: "分銷商好評率" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl font-bold text-amber-400">{stat.value}</div>
                <div className="text-white/50 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
